/* eslint-disable @typescript-eslint/naming-convention */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { routeAnimations } from 'app/core/animations/route.animations';
import { Client } from 'app/features/admin/clients/model/Client';
import { EditingStatus } from 'app/core/models/common-types';
import { UiStateService } from 'app/core/store/ui/state-service';
import { Observable, Subscription } from 'rxjs';
import { APP_TITLE_LONG } from '@core/models/common-ux-types';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PrimeNgModule } from '@core/primeng.module';
import { ProductStateService } from 'app/features/admin/products/store/products.state-service';
import { AuthStateService } from 'app/auth/store/auth.state-service';
import { ServiceProductStateService } from '../service-products/store/service-products.state-service';
import { ClientStateService } from '../clients/store/client.state-service';
import { isAdminUser } from 'app/auth/model/types';

@Component({
  selector: 'app-rc-admin-view',
  templateUrl: './admin-view.component.html',
  standalone: true,
  imports: [CommonModule, PrimeNgModule],
  animations: [routeAnimations],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminViewComponent implements OnInit, OnDestroy {
  isAddingNewClientProject$: Observable<boolean>;
  isAdminUser = false;
  isPropertyManager = false;
  selectedClient: Client;
  selectedIndex = 0;
  APP_TITLE_LONG = APP_TITLE_LONG;
  showUsersList = false;

  EditingStatus = EditingStatus;
  gamePlanEditStatus = EditingStatus.NOT_EDITING;

  private subscriptions = new Subscription();
  constructor(
    private changeDetector: ChangeDetectorRef,
    private authStateService: AuthStateService,
    private clientStateService: ClientStateService,
    private serviceProductStateService: ServiceProductStateService,
    private uiStateService: UiStateService,
    private router: Router,
    private productStateService: ProductStateService
    // private gamePlanStateService: GamePlanStateService
  ) { }

  ngOnInit() {
    console.log('MS AdminViewComponent ngOnInit ');
    this.uiStateService.setIsAdminActive(true);

    this.authStateService.loadUsers();
    // this.clientStateService.loadClients(); already loaded
    this.productStateService.loadProducts();
    this.serviceProductStateService.loadServiceProducts();

    // this.subscriptions.add(
    //   this.productStateService.isLoaded$.subscribe(isLoaded => {
    //     if (isLoaded) {
    //       this.sportBetStateService.loadSportBets();
    //     }
    //   })
    // );

    this.subscriptions.add(
      this.authStateService.loggedInUser$.subscribe((loggedInUser) => {
        if (loggedInUser) {
          this.isAdminUser = isAdminUser(loggedInUser.userType);

          console.log('MS AdminViewComponent this.isAdminUser', this.isAdminUser);
          this.changeDetector.detectChanges();
        }
        // console.log('MS AdminViewComponent this.isAdminUser', this.isAdminUser);
        // this.rcAdminStateService.loadClients();
      })
    );
  }

  onNavigate(dest: string) {
    switch (dest) {
      case 'Users':
        this.router.navigate(['/admin/users-list']);
        break;
      case 'Products':
        this.router.navigate(['/admin/product-list']);
        break;
      case 'Clients':
        this.router.navigate(['/admin/clients-list']);
        break;
      case 'Services':
        this.router.navigate(['/admin/service-list']);
        break;
    }
  }
  // selectedIndexChange(event) {
  //   console.log('MS selectedIndexChange event = ', event);
  //   this.selectedIndex = event;
  //   this.uiStateService.setSelectedAdminTabIndex(this.selectedIndex);
  //   console.log('MS selectedIndexChange selectedIndexent= ', this.selectedIndex);
  // }
  ngOnDestroy() {
    console.log('MS AdminViewComponent ngOnDestroy ');
    // this.uiStateService.setIsAdminActive(false);
    // this.customerStateService.setCustomerEditingStatus(EditingStatus.NOT_EDITING);
    // this.projectStateService.setProjectEditingStatus(EditingStatus.NOT_EDITING);
    // this.gamePlanStateService.setGamePlanEditingStatus(EditingStatus.NOT_EDITING);
    this.subscriptions.unsubscribe();
  }
}
